<script lang="ts">
  import { browser } from '$app/environment';
  import { goto } from '$app/navigation';
  import { useFindFirstAccountPlan, useFindFirstProfile } from '$lib/hooks/zenstack';
  import { cn } from '$lib/utils';
  import { onMount } from 'svelte';
  import { toast } from 'svelte-sonner';

  $: accountPlan = useFindFirstAccountPlan(
    {},
    {
      enabled: browser,
      onSettled(data) {
        if (!data) {
          toast.info('Plan Required', {
            description: 'You must select a plan to access this page.'
          });
          goto(
            `/?toast[title]=Plan Required&toast[description]=You must select a plan to access this page.&toast[type]=fail`
          );
        }
      },
      refetchOnMount: true
    }
  );

  onMount(() => {
    $accountPlan.refetch();
  });
</script>

<div class={cn({ 'opacity-0': !$accountPlan.data }, 'relative mx-auto')}>
  <slot />
</div>
